import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

export interface Dept {
    deptId: number;
    pid: number;
    companyName: string;
    name: string;
    num: number;
    remark: string;
    deptHeadId: number;
    deptHeadName: string;
    currentNum: number;
    children?: Dept[];
}

export interface QueryDeptBO {
    pid: number;
}

const defaultUrl = BASE_ADMIN_API + '/dept'

// 查询部门列表树
export async function useDeptTreeList(deptBO: QueryDeptBO = {pid: 0}) {
    return fetchAPI<Dept[]>(`${defaultUrl}/queryDeptTree`, {
        method: 'POST',
        body: JSON.stringify(deptBO),
    });
}

export async function queryDeptMsg() {
    return fetchAPI<{}>(`${defaultUrl}/queryDeptMsg`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function getDeptById(deptId: number) {
    return fetchAPI<Dept[]>(`${defaultUrl}/getDeptById/${deptId}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

export async function createDept(dept: Omit<Dept, 'deptId'>) {
    return fetchAPI<Dept>(`${defaultUrl}/createDept`, {
        method: 'POST',
        body: JSON.stringify(dept),
        headers: {'Content-Type': 'application/json'},
    });
}

export async function useDeleteDept(deptId: number) {
    return fetchAPI<void>(`${defaultUrl}/deleteDept/${deptId}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

// 更新部门
export async function updateDept(deptId: number, adminDeptBO: any) {
  return fetchAPI<Dept>(`${defaultUrl}/updateDept/${deptId}`, {
    method: 'POST',
    body: JSON.stringify(adminDeptBO),
    headers: { 'Content-Type': 'application/json' },
  });
}
